import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons/faChevronRight";

import {CSSProperties, ReactNode} from "react";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import './Style.css';
import {Spring} from "shared/core/animation/react-spring/renderprops";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";


library.add(faChevronRight);

export class AccordionItem extends React.Component<AccordionItemProps, AccordionItemState> {
    static defaultProps: Partial<AccordionItemProps> = {
        IsOpen:false,
        Padding:10,
        RightSide:null
    };
    accordionContent:HTMLDivElement;


    constructor(props: AccordionItemProps) {
        super(props);
        this.state = {
            Status:this.props.IsOpen?ShowStatus.Showed:ShowStatus.Hidden
        };
    }

    componentWillReceiveProps(nextProps: Readonly<AccordionItemProps>, nextContext: any): void {
        if(nextProps.IsOpen!=this.props.IsOpen)
        {
            if(nextProps.IsOpen)
                this.setState({Status:ShowStatus.Showing});
            else
                this.setState({Status:ShowStatus.Hiding});

        }
    }

    public render() {

        let toStyle:CSSProperties={};
        let chevronFromStyle:CSSProperties={};
        let chevronToStyle:CSSProperties={};

        chevronFromStyle={
            transform:'rotate(0deg)'
        };



        let isImmediate=true;
        let fromStyle={};
        switch(this.state.Status)
        {
            case ShowStatus.Hiding:
                isImmediate=false;
                if(this.accordionContent!=null)
                    fromStyle={height:this.accordionContent.offsetHeight}
                toStyle={
                    height:0,
                    display:'block',
                    overflow:"hidden",
                    paddingTop:0,
                    paddingBottom:0,
                    paddingLeft:this.props.Padding,
                    paddingRight:this.props.Padding

                };

                chevronToStyle={
                    transform:'rotate(0deg)'
                };
                break;
            case ShowStatus.Hidden:
                toStyle={
                    height:0,
                    display:"none",
                    overflow:"auto",
                    paddingTop:0,
                    paddingBottom:0,
                    paddingLeft:this.props.Padding,
                    paddingRight:this.props.Padding
                };


                chevronToStyle={
                    transform:'rotate(0deg)'
                };
                break;
            case ShowStatus.Showing:
                isImmediate=false;


                toStyle={
                    height:'auto',
                    display:'block',
                    overflow:"hidden",
                    paddingTop:this.props.Padding,
                    paddingBottom:this.props.Padding,
                    paddingLeft:this.props.Padding,
                    paddingRight:this.props.Padding
                };
                chevronToStyle={
                    transform:'rotate(90deg)'
                };
                break;
            case ShowStatus.Showed:
                toStyle={
                    display:'block',
                    overflow:"auto",
                    paddingTop:this.props.Padding,
                    height:'auto',
                    paddingBottom:this.props.Padding,
                    paddingLeft:this.props.Padding,
                    paddingRight:this.props.Padding
                };
                chevronToStyle={
                    transform:'rotate(90deg)',
                };
                break;

        }

        return (
            <div >
                <div className={'rnAccordionItem'} style={{display:'flex',alignItems:'center', ...this.props.TitleStyle,position:'relative'}} onClick={e=>{e.preventDefault();this.ToggleOpen()}}>
                    <a style={{marginLeft:5,fontWeight:'bold'}} href={'#'} >
                    <Spring immediate={isImmediate} config={{precision:.09}} to={chevronToStyle} >
                        {style=>{
                            return(
                                <div style={{display:'inline-block',...style}}>
                                    <FontAwesomeIcon icon={"chevron-right"}/>
                                </div>
                            )}}
                    </Spring>
                    <div style={{marginLeft:3,display:'inline'}}>{this.props.Title}</div></a>

                    {this.props.RightSide!=null&&
                    <div style={{position:'absolute',right:5}}>
                        {this.props.RightSide}
                    </div>}
                </div>
                <Spring immediate={isImmediate}  from={fromStyle} to={toStyle} config={{precision:.09}}  onRest={e=>this.OnRestReached()}>
                    {
                        (   (styles,ref)=>{
                            if(this.state.Status==ShowStatus.Hidden)
                                return null;

                            return(
                                <div ref={x=>{this.accordionContent=x;ref(x)}} style={{...styles,boxSizing:'border-box',height:styles.height==undefined?'auto':styles.height,border:'1px solid #dfdfdf',...this.props.ContentStyles}} className={'rnAccordionContent'}>
                                    {this.props.children}
                                </div>
                            )
                        } )as any
                    }

                </Spring>

            </div>
        )
    }

    private ToggleOpen() {

        let newState=this.state.Status==ShowStatus.Hidden||this.state.Status==ShowStatus.Hiding?ShowStatus.Showing:ShowStatus.Hiding;
        ReactUtilities.ExecuteMethodPropIfDefined(this.props.IsOpenChanging,newState==ShowStatus.Showing);
        this.setState({Status:newState});
    }

    private OnRestReached() {
        switch(this.state.Status)
        {
            case ShowStatus.Showed:
                ReactUtilities.ExecuteMethodPropIfDefined(this.props.IsOpenChanged,true);
                break;
            case ShowStatus.Hidden:
                ReactUtilities.ExecuteMethodPropIfDefined(this.props.IsOpenChanged,false);
                break;
            case ShowStatus.Hiding:
                this.setState({Status:ShowStatus.Hidden});
                break;
            case ShowStatus.Showing:
                this.setState({Status:ShowStatus.Showed});
        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface AccordionItemProps {
    Title:string|ReactNode;
    IsOpen:boolean;
    IsOpenChanging?:(isOpen:boolean)=>void;
    IsOpenChanged?:(isOpen:boolean)=>void;
    TitleStyle?:CSSProperties;
    Padding:number;
    RightSide:any;
    ContentStyles?:CSSProperties;
}

interface AccordionItemState {
    Status:ShowStatus


}

enum ShowStatus{
    Showing,
    Showed,
    Hiding,
    Hidden
}

//#endregion "My Region"